<template lang="html">
    <div class="container">

      <div class="filter-header">
        <span class="area">{{filterName.name}}</span>
        <span class="time">{{begin_time}}-{{end_time}}</span>
        <i class="icon iconfont icon-shaixuan" @click="showFilter"></i>
      </div>

      <ul class="field-wrappwe">

        <li class="field-item" @click="toDetail">
          <p class="item-value"> <span class="symbol">¥</span>{{(data.totalBackMoney/10000).toFixed(2)}}<span class="unit">(万)</span></p>
          <p class="item-name">已回款</p>
        </li>

        <li class="field-item" @click="toDetail">
          <p class="item-value"> <span class="symbol">¥</span>{{(data.totalSaleMoney/10000).toFixed(2)}}<span class="unit">(万)</span></p>
          <p class="item-name">已签约</p>
        </li>

      </ul>


      <div class="list-wrapper">
        <!-- data.pc -->
        <div class="list-item" v-for="(item,index) in projectList" >

          <div class="row text">
            <span>{{ item.start_date }}</span>
            <span>{{ item.region_name}}</span>
          </div>

          <div class="row text">
            <span>{{ item.first_party }}</span>
            <span>{{ item.group_name}}</span>
          </div>

          <div class="row text">
            <span>{{ item.p_name }}</span>
            <span>{{ status[item.status]}}</span>
          </div>

          <div class="row">

            <div class="row-item">
              <p class="item-value"> <span class="symbol">¥</span>{{ (item.b_money/10000).toFixed(2) }}<span class="unit">(万)</span></p>
              <p class="item-name">已回款金额</p>
            </div>

            <div class="row-item center">
              <p class="item-value"> <span class="symbol">¥</span>{{ (item.t_money/10000).toFixed(2) }}<span class="unit">(万)</span></p>
              <p class="item-name">项目金额</p>
            </div>

            <div class="row-item">
              <p class="item-value charge">{{ item.name }}</p>
              <p class="item-name">负责人</p>
            </div>

          </div>
        </div>

      </div>

      <div class="btn" v-if="data.pc.length > 5 " @click="showMore">{{  showMoreProject ? '收起' : '查看全部项目' }}</div>


      <div class="rank">

        <p class="test">
          销售排名变化趋势
        </p>
        <div class="echarts">
          <IEcharts :option="line" @click="toRank"></IEcharts>
        </div>

      </div>

      <div class="alert-list" v-if="alertData.length">
        <p class="test">{{begin_time}}-{{end_time}}回款预警项目</p>

        <div class="list-wrapper">

          <div class="list-item" v-for=" item in alertData">

            <div class="row text">
              <span><span class="title">逾期时间</span>{{ Number(item.seconds).toFixed(0) }}天</span>
              <span>{{ item.group_name }}</span>
            </div>

            <div class="row text">
              <span><span class="title">最后开票时间</span>{{ item.last_billed ? item.last_billed : '未开票' }}</span>
              <span>{{ status[item.status]}}</span>
            </div>

            <div class="row text">
              <!--<span><span class="title group">{{ item.first_party }}</span>{{ item.p_name }}</span>-->
              <span>{{ item.p_name }}</span>
              <!--<span><span class="title">负责人</span>{{ item.sales }}</span>-->
              <span v-if="item.rat<2"  class="green">佣金:100%</span>
              <span v-if="item.rat>=2&&item.rat<6" class="yellow">佣金:80%</span>
              <span v-if="item.rat>=6" class="red">佣金:50%</span>

            </div>

            <div class="row">

              <div class="row-item">
                <p class="item-value"> <span class="symbol">¥</span>{{ (item.b_money/10000).toFixed(2) }}<span class="unit">(万)</span></p>
                <p class="item-name">已回款金额</p>
              </div>

              <div class="row-item center">
                <p class="item-value"> <span class="symbol">¥</span>{{(item.p_money/10000).toFixed(2)  }}<span class="unit">(万)</span></p>
                <p class="item-name">项目金额</p>
              </div>

              <div class="row-item">
                <p class="item-value"> <span class="symbol">¥</span>{{(item.y_no_money/10000).toFixed(2)}}<span class="unit">(万)</span></p>
                <p class="item-name">已开发票待回款</p>
              </div>

            </div>
          </div>

          <!-- <nodata></nodata> -->
        </div>
      </div>


      <div class="zhezhao" v-if="isFilter" @click="isFilter = false"></div>

      <!--筛选-->
      <div class="selbox" v-if="isFilter">
        <p>筛选</p>

        <p class="content">
          时间
        </p>

        <ul class="listtime">
          <mt-picker :slots="slots" @change="onDateChange" class="inner-picker" :visibleItemCount="3"></mt-picker>
        </ul>

        <p  class="content">
          销售
        </p>
        <ul  class="listtime">
          <mt-picker :slots="saleSlots" @change="onSaleChange" valueKey="name" class="inner-picker" :visibleItemCount="3"></mt-picker>
        </ul>

        <p class="btnyes" @click="confirmFilter">确定</p>
      </div>

    </div>
</template>

<script>
import '../assets/css/drillStyle.css'
import '../assets/css/filterModal.css'
import slotsList from '../assets/js/slotsList'
import dateChange from '../mixins/dateChange.js'
import nodata from './public/nodata'
import config from '../fetch/config'
import IEcharts from 'vue-echarts-v3/src/lite.js'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
export default {
  components: {
    IEcharts,
    nodata,
  },
  mixins:[dateChange],
  data () {
    return {
      filterName:{},
      isFilter:false,
      showMoreProject: false,

      data:{pc:[]},
      begin_time:null,
      end_time:null,
      c_sale:null, //暂存选择的销售
      nameData:null, //旗下销售列表
      slots:slotsList.Monthslots(), //日期选择

      projectList:[], //项目列表
      alertData:[], //预警项目列表


      status:{
        0:'待处理',
        1:'开发中',
        2:'已交付',
        3:'已暂停',
        4:'已关闭',
        5:'已完结',
      }, //状态

      line:{
        tooltip : {
          trigger: 'axis',
        },
        grid: {
          left: '6%',
          right: '12%',
          top:'6%',
          bottom: '18%',
          containLabel: true
        },
        legend: {
          icon: 'rect', //设置图例的图形形状，circle为圆，rect为矩形
          itemWidth: 25, //图例标记的图形宽度[ default: 25 ]
          itemHeight: 2, //图例标记的图形高度。[ default: 14 ]
          itemGap: 50, //图例每项之间的间隔。横向布局时为水平间隔，纵向布局时为纵向间隔。[ default: 10 ]
          data: ['回款排名', '销售排名'],
          bottom:'3%',
          // right: '26%', //图例组件离容器右侧的距离
          textStyle: {
              fontSize: 12,
              color: '#475669'
          }
        },
        xAxis: [{
          type: 'category',
          // name:'(月)',
          // nameLocation:'start',
          position:'top',
          axisTick: {
              // alignWithLabel: true
              show:false,
          },
          axisLabel:{
            textStyle:{
              color:'#475669'
            }
          },
          nameTextStyle:{
            color:'#475669',
            align:'center',
            fontSize:12,
            // padding:[0,0,266,-10]
          },
          axisLine:{
            lineStyle:{
              color:'#E4E4E4',
            }
          },
          data: ['1','2','3','4','5','6','7','8','9','10','11','12'],
        }],
        yAxis: [{
         type: 'value',
         name: '',
         min: 0,
         axisTick:{
           show:false,
         },
         axisLine:{
           show:true,
           lineStyle:{
             color:'#E4E4E4',
           }
         },
        //  splitLine: {
        //     show: false
        //  },
         nameTextStyle:{
           color:'#333',
           align:'center',
           fontSize:12,
         },
         axisLabel:{
           textStyle:{
             color:'#475669'
           }
         },
        }],
       series: [{
          name: '销售排名',
          color:['#9A89F1'],
          type: 'line',
          label: {
              normal: {
                  show: false,
                  position: 'top',
              }
          },
          lineStyle: {
              normal: {
                  width: 1,
              }
          },
          areaStyle:{
              normal:{
                  color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [{
                          offset: 0, color: '#9A89F1' // 0% 处的颜色
                      },  {
                          offset: 0.5, color: 'rgba(154,137,241,0.1)' // 100% 处的颜色
                      }],
                      globalCoord: false // 缺省为 false
                  }
              }
          },
          data: []
        }, {
            name: '回款排名',
            color:['#76B2F9'],
            type: 'line',
            label: {
                normal: {
                    show: false,
                    position: 'top',
                }
            },
            lineStyle: {
                normal: {
                    width: 1,
                }
            },
            areaStyle:{
                normal:{
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                            offset: 0, color: '#76B2F9' // 0% 处的颜色
                        },  {
                            offset: 0.5, color: 'rgba(118,178,249,.1)' // 100% 处的颜色
                        }],
                        globalCoord: false // 缺省为 false
                    }
                }
            },
            data: []
        }]
      },
    }
  },
  methods:{
    showFilter (type) {
      this.slots = slotsList.Monthslots(this.begin_time,this.end_time)
      this.isFilter = true
    },

    showMore () {
      this.showMoreProject = !this.showMoreProject
      this.showMoreProject ? this.projectList = this.data.pc : this.projectList = this.data.pc.slice(0,5)
    },

    getTime () {
        var d = new Date();
        var result = [];
        var y = d.getFullYear()
        var m = d.getMonth() + 1
        this.begin_time = this.end_time = `${y}/${m}`
    }, //获取当前年和月份

    confirmFilter (type, item) { //过滤确定
      this.isFilter = false
      this.begin_time = this.c_begin_time
      this.end_time = this.c_end_time
      this.filterName = this.c_sale
      let data = {
        begin_time:this.begin_time,
        end_time:this.end_time,
        id:this.filterName.id
      }
      this.getData(data)
    },

    getData (data) { //获取数据
      this.$notice.loading()
      this.$http.getSaleAlert(data).then( res => {
        this.alertData = res.data.data
      })

      this.$http.getSaleData(data).then( res => {

        this.data = res.data

        this.projectList = this.data.pc.slice(0,5)
        this.line.series[0].data = res.data.sort.sSort
        this.line.series[1].data = res.data.sort.bSort
        this.$notice.loading(false)
      })

    },

    onSaleChange (picker, values) { //选择销售
      this.c_sale = values[0]
    },

    toDetail () {
      let data = {
        id:window.localStorage.getItem('userId'),
        begin_time: this.begin_time,
        end_time: this.end_time,
        type:2,
      }
      window.localStorage.setItem('drillData',JSON.stringify(data) )
      this.$router.push({name:'backdetail'})
    },

    toRank (event) {

      let data = {
        begin_time:this.begin_time,
        end_time:this.end_time,
        type:2,
      }
      window.localStorage.setItem('drillData',JSON.stringify(data) )
      this.$router.push({name:'backrank'})

    },
  },
  computed:{
    saleSlots () {
      return [{
          flex: 1,
          values: this.nameData,
          className: 'area',
          textAlign: 'center',
      }]
    },
  },

  created () {
    this.getTime()
    let id = window.localStorage.getItem('userId')

    this.$http.getUserList(id).then( res => {
      this.nameData = res.data
      this.filterName = this.nameData.filter( item => item.id == id )[0]
    })

    let data = {
      begin_time:this.begin_time,
      end_time: this.end_time,
      id,
    }

    this.getData(data)


  }
}
</script>

<style lang="css" scoped>
  .green{
    color:green
  }
  .yellow{
    color:orange
  }
  .red{
    color:red
  }

  .container {
        width: 100%;
        background-color: #fafafa;
        color: #333;
        font-family: PingFangSC-Regular;
    }
    .header{
        width: 100%;
        text-align: center;
        font-size: 0.375rem;
        background-color: #FFF;
        height: 1.90625rem;
        line-height: 0.9375rem;
        position: relative;
        z-index: 99;
    }
    .header p{
        color: #333;
        font-size: 0.4375rem;
    }
    .yes{
        color: #333333!important;
        font-size: 0.3125rem!important;
        font-weight: 600!important;
    }
    .container nav {
        background-color: #FFF;
        border-bottom:1px solid #ccc;
        z-index: 99;
        position: sticky;
        z-index:99;
        text-align: center;
    }
    .container nav a{
        color: #999;
        font-size:0.3125rem;
        text-decoration: none;
        width: 2.125rem;
        display: inline-block;
        text-align: left;
        padding-left: 0.3125rem;
        height: 0.625rem;
        line-height: 0.625rem;
        background: #F1F5F8;
        font-family: PingFangSC-Regular;
        border-radius: 2.0625rem;
        margin-bottom: 0.09375rem;
        font-weight: 500;
        position: relative;
    }
    .container nav a.yes .icon-sanjiaoxiabiao{
      transition: .4s all;
      transform: rotate(0deg);
    }
    .icon-sanjiaoxiabiao{
      font-size: 0.375rem;
      line-height: 0.625rem;
      position: absolute;
      right: 6%;
      transform: rotate(-180deg);
    }
    .container nav a:first-child{
        margin-right: 1.78125rem;
    }
    /*.iconfont{
        color: #5483D2;
        font-weight: 600;
    }*/


    .rank{
        color: #000;
        height: 6.4375rem;
        position: relative;
        width: 100%;
        background: #fff;
        margin-bottom: 0.1875rem;
    }
    .percent2{
        color: #000;
        position: relative;
        width: 100%;
        background: #fff;
        margin-bottom: 0.1875rem;
    }
    .percent2 ul{
        width: 100%;
        margin: auto;
        background: #fafafa;
        height: 100%;
    }
    .percent2 ul li{
        position: relative;
        width: 95%;
        margin: auto;
        background: #fff;
        margin-bottom: 0.15625rem;
        border-radius: 0.09375rem;
        height: 2.5625rem;
    }
    .percent2 ul li h2{
        color: #333333;
        font-size: 0.4375rem;
        font-weight: 500;
        padding-left:0.375rem;
        margin-top: 0.09375rem;
        font-family:PingFangSC-Regular;
        border-left: 0.09375rem solid #5483D2;
        height: 0.9375rem;
        line-height: 1.09375rem;
        margin-bottom: 0.15625rem;
    }

    .spantxtpos{
        padding-top: 0.15625rem;
    }

    .test{
        border-left: 0.0625rem solid #5483D2;
        width: 100%;
        height: 0.5625rem;
        line-height: 0.5625rem;
        font-size:0.375rem;
        color: #333333;
        font-family:PingFangSC-Regular;
        padding-left: 2%;
        font-weight: 500;
    }
    .test span{
        position: absolute;
        right: 5%;
        font-family:PingFangSC-Regular;
        color:rgba(153,153,153,1);
        font-size:0.375rem;
    }
    .echarts{
      height: 5.875rem;
    }
    .back{
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
        display: inline-block;
        position: absolute;
        left: 2%;
        top: 5%;
        height: 0.78125rem;
        line-height: 0.78125rem;
        color: #86898E;
    }


    .txtleft{
        width: 49%;
        float: left;
        text-align: center;
        color: #5483D2;
        font-size:0.5rem;
        clear: both;
        height: 1.53125rem;
    }
    .txtright{
        width: 49%;
        float: right;
        text-align: center;
        color: #5483D2;
        font-size:0.5rem;
        height: 1.53125rem;
    }
    .pre{
        font-size: 0.375rem;
        color: #333;
        display: block;
    }

    .small{
        font-size: 0.34375rem;
        display: inline-block;
        color: #5483D2;
    }
    .numbox{
        height: 3.0625rem;
        width: 100%;
        margin-bottom: 0.15625rem;
        background: #fff;
    }

    .pan{
        height: 1.875rem;
        width: 0.09375rem;
        background: #E9E9E9;
        position: absolute;
        left: 50%;
        top: 2.3125rem;
    }
    .downlist{
        position: absolute;
        z-index: 99;
        width: 100%;
        top: 1.90625rem;
    }
    .downlist ul{
        width: 100%;
        background: #fff;
        color: #333333;
        font-size: 0.34375rem;
    }
    .downlist ul li{
        height: 1.03125rem;
        line-height: 1.03125rem;
        padding-left: 0.4375rem;
        border-bottom: 1px solid #CCCCCC;
        position: relative;
        font-family: PingFangSC-Regular;
    }
    .testcol{
        color: #5483D2;
    }
    .downlisttime{
        position: absolute;
        z-index: 99;
        width: 100%;
        top: 1.90625rem;
    }
    .downlisttime ul{
        width: 100%;
        height: 6.15rem;
        overflow: scroll;
        background: #fff;
        color: #333333;
        font-size:0.34375rem;
    }
    .downlisttime ul li{

        height: 1.03125rem;
        line-height: 1.03125rem;
        padding-left: 0.4375rem;
        border-bottom: 1px solid #CCCCCC;
        position: relative;
        font-family:PingFangSC-Regular;
    }
    .testcol{
        color: #5483D2;
    }
    .click{
        font-size: 0.3125rem;
        position: absolute;
        top: 0.0625rem;
        right: 3.5%;
    }

    .btn{
      border: 1px solid #5483D2;
      color: #5483D2;
      width: 5.4375rem;
      margin: 0.46875rem auto 0.25rem;
      border-radius: 1.5625rem;
      line-height: 1.6;
      text-align: center;
      font-size: 0.4375rem;
    }


</style>



// WEBPACK FOOTER //
// src/components/Sales.vue